import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const dataAnalyticsExercises: TopicExercises = {
  mcqs: [
    {
      id: "da1",
      difficulty: "easy",
      question: "Basic statistical model ka example kya hai?",
      options: ["Linear Regression", "Neural Network", "Decision Tree", "Support Vector Machine"],
      correctIndex: 0,
      explanation: "Correct answer 'Linear Regression' hai kyun ke FSC level par yeh sab se simple statistical model hai jo trend dekh kar prediction karta hai. Baqi options zyada advanced ML models hain.",
    },
    {
      id: "da2",
      difficulty: "easy",
      question: "Experimental design me pehla step kya hota hai?",
      options: ["Visualization banana", "Data collect aur analyze karna", "Machine learning code likhna", "Database banana"],
      correctIndex: 1,
      explanation: "Correct answer 'Data collect aur analyze karna' hai kyun ke experiment tabhi meaningful hota hai jab pehle relevant data liya jaye. Visualization aur coding baad ki cheezein hain.",
    },
    {
      id: "da3",
      difficulty: "easy",
      question: "Data visualization ke liye common tool konsa hai?",
      options: ["MS Excel", "Python (Matplotlib)", "Tableau", "All of the above"],
      correctIndex: 3,
      explanation: "Correct answer 'All of the above' hai kyun ke Excel, Python aur Tableau teeno data ko chart aur graph me dikhane ke liye use hote hain.",
    },
    {
      id: "da4",
      difficulty: "medium",
      question: "Linear regression me slope ka kya matlab hota hai?",
      options: ["Model ka intercept", "Dependent variable me change per unit change", "Error term", "Data ka average"],
      correctIndex: 1,
      explanation: "Correct answer 'Dependent variable me change per unit change' hai kyun ke slope batata hai ke input me 1 unit change se output kis direction aur kitni amount me move karta hai.",
    },
    {
      id: "da5",
      difficulty: "easy",
      question: "Statistical model ka real-life example kya ho sakta hai?",
      options: ["House prices predict karna", "Social media post banana", "Website design karna", "Essay likhna"],
      correctIndex: 0,
      explanation: "Correct answer 'House prices predict karna' hai kyun ke statistical model data dekh kar future ya unknown value ka andaza lagata hai. Baqi options direct prediction tasks nahi hain.",
    },
    {
      id: "da6",
      difficulty: "easy",
      question: "Data visualization ka faida kya hai?",
      options: ["Trends aur patterns dekhna", "Insights communicate karna", "Data ko samajhna easy banana", "All of the above"],
      correctIndex: 3,
      explanation: "Correct answer 'All of the above' hai kyun ke visualization trends bhi dikhati hai, explanation bhi easy karti hai, aur insights ko dusron tak clear tareeqay se pohnchati hai.",
    },
    {
      id: "da7",
      difficulty: "medium",
      question: "K-means clustering ka main goal kya hai?",
      options: ["Data ko predefined categories me daalna", "Similar data ko groups me divide karna", "Continuous values predict karna", "Dimensions reduce karna"],
      correctIndex: 1,
      explanation: "Sahi jawab 'Similar data ko groups me divide karna' hai kyun ke K-means milte julte data ko aik group me rakhta hai. Yeh prediction karne ka tool nahi hota.",
    },
    {
      id: "da8",
      difficulty: "medium",
      question: "K-means me 'K' ka matlab kya hai?",
      options: ["Features ki number", "Clusters ki number", "Iterations ki number", "Data points ki number"],
      correctIndex: 1,
      explanation: "Correct answer 'Clusters ki number' hai kyun ke K specify karta hai ke data ko kitne groups me divide karna hai.",
    },
  ],
  short: [
    {
      id: "da-short-1",
      question: "Data analytics me models important kyun hote hain?",
      answer: "Models data ke andar pattern dekhne aur simple prediction karne me help karte hain. In ki wajah se raw numbers ko decision me convert karna easy hota hai.",
    },
    {
      id: "da-short-2",
      question: "Bar chart aur line chart me basic farq kya hai?",
      answer: "Bar chart categories compare karne ke liye achha hota hai, jab ke line chart time ke sath trend dikhane ke liye zyada useful hota hai.",
    },
    {
      id: "da-short-3",
      question: "Experimental design ka simple idea kya hai?",
      answer: "Pehle data lo, phir hypothesis test karo, aur akhir me result evaluate karke decide karo ke idea kaam kar raha hai ya nahi.",
    },
  ],
  long: [
    {
      id: "da-long-1",
      question: "Linear regression ko simple words me explain karo.",
      solution: "Linear regression ek simple trend model hai jo data ke points ko dekh kar andaza lagata hai ke agla result kis direction me ja sakta hai. Is liye ise house prices ya marks prediction jaise examples me samjhaya jata hai.",
      steps: ["Pehle existing data dekho.", "Phir us me trend identify karo.", "Trend line ke basis par next value ka estimate lagao.", "Result ko exact truth nahi, balkay reasonable prediction samjho."],
    },
    {
      id: "da-long-2",
      question: "Data visualization ki importance explain karo.",
      solution: "Data visualization numbers ko visual form me dikhati hai taake trends, comparison aur changes jaldi samajh aayein. Is se communication aur decision making dono better hoti hain.",
      steps: ["Raw data ko chart ya graph me badlo.", "Pattern aur trend ko highlight karo.", "Audience ko insight asani se samjhao."],
    },
    {
      id: "da-long-3",
      question: "Experimental design ko basic example ke sath explain karo.",
      solution: "Experimental design me hum kisi idea ko test karte hain. Example ke liye agar app ka naya button users ko zyada click karwata hai ya nahi, to dono versions compare karke result dekha jata hai.",
      steps: ["Question ya hypothesis define karo.", "Relevant data collect karo.", "Old aur new result compare karo.", "Jo version better ho us par decision lo."],
    },
  ],
};
